import { render, staticRenderFns } from "./potential-breach.vue?vue&type=template&id=0d7d6abf&scoped=true&"
import script from "./potential-breach.vue?vue&type=script&lang=js&"
export * from "./potential-breach.vue?vue&type=script&lang=js&"
import style0 from "./potential-breach.vue?vue&type=style&index=0&id=0d7d6abf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7d6abf",
  null
  
)

export default component.exports